import FlexibleLink from 'src/components/ui/FlexibleLink/FlexibleLink'
import { Picture } from 'src/components/ui/Image'
import type { GridCategoriesCardData } from 'src/types/gridCategories2'

interface CategoryGridCardProps {
  card: GridCategoriesCardData
  cardPositionClass: string
  desktopWidth: number
  desktopHeight: number
}

export default function CategoryGridCard({
  card,
  cardPositionClass,
  desktopWidth,
  desktopHeight,
}: CategoryGridCardProps) {
  const cardTitle = card.title.trim()
  const altText = card.altText.trim()
  const desktopSrc = card.desktopImage
  const mobileSrc = card.mobileImage

  return (
    <article
      data-testid="grid-categories-2-0-card"
      className={`relative h-[241px] overflow-hidden lg:h-full ${cardPositionClass}`}
    >
      <FlexibleLink
        linkUrl={card.link}
        classNames="group block h-full w-full outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primaryBlue focus-visible:ring-offset-2"
      >
        <Picture
          className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
          sources={[
            {
              src: mobileSrc,
              width: 390,
              height: 241,
              media: '(max-width: 768px)',
            },
            {
              src: desktopSrc,
              width: desktopWidth,
              height: desktopHeight,
              media: '(min-width: 769px)',
            },
          ]}
          img={{
            src: desktopSrc,
            width: desktopWidth,
            height: desktopHeight,
            alt: altText,
          }}
          shouldCompress={false}
        />

        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />

        <h3 className="absolute bottom-5 left-4 right-4 text-base font-semibold leading-[1.2] tracking-[-0.3px] text-white lg:text-[22px]">
          {cardTitle}
        </h3>
      </FlexibleLink>
    </article>
  )
}
